/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OnboardingStatusResponseOnboardingMode = typeof OnboardingStatusResponseOnboardingMode[keyof typeof OnboardingStatusResponseOnboardingMode];


export const OnboardingStatusResponseOnboardingMode = {
  full: 'full',
  profile_only: 'profile_only',
} as const;
